import {
  AVAILABLE_CHIP_TAGS,
  CUSTOM_TAG,
  CUSTOM_TAG_NAME,
  CUSTOM_TAG_VALUE,
  SYSTEM_TAG_BRANDS,
  SYSTEM_TAG_IAB,
  SYSTEM_TAG_KEYWORDS,
  SYSTEM_TAG_PEOPLE,
} from '../constants/label';

import { createFlatTreeMap } from '@/mui/helpers/treeView';

import { getIntersection } from './array';

let allowedChipTagTypes = AVAILABLE_CHIP_TAGS;

export const setAllowedChipTagTypes = (tagTypes) => {
  allowedChipTagTypes = tagTypes;
};

export const collectVideoEntities = (video) => {
  const iabEntityTypes = [];
  if (allowedChipTagTypes.includes(SYSTEM_TAG_IAB) && video?.iab?.categories) {
    createFlatTreeMap(video.iab.categories, {
      label: 'name',
      children: 'categories',
    }).forEach((iab$) => {
      iabEntityTypes.push({
        id: iab$.id,
        type: SYSTEM_TAG_IAB,
        value: iab$.label,
      });
    });
  }

  let keywordEntityTypes = [];
  if (getIntersection(allowedChipTagTypes, [SYSTEM_TAG_PEOPLE, SYSTEM_TAG_BRANDS, SYSTEM_TAG_KEYWORDS]).length) {
    keywordEntityTypes = (video.keywords || []).reduce((acc, keyword) => {
      if (allowedChipTagTypes.includes(keyword.category)) {
        acc.push({
          type: keyword.category,
          value: keyword.value,
        });
      }
      return acc;
    }, []);
  }

  let labelEntityTypes = [];
  const allowedName = allowedChipTagTypes.includes(CUSTOM_TAG_NAME);
  const allowedValue = allowedChipTagTypes.includes(CUSTOM_TAG_VALUE);
  if (allowedName || allowedValue) {
    labelEntityTypes = (video.label || []).reduce((acc, label$) => {
      const entities = [
        allowedName && {
          type: CUSTOM_TAG_NAME,
          value: label$.name,
        },
        allowedValue && {
          type: CUSTOM_TAG_VALUE,
          value: label$.value,
        },
      ].filter(Boolean);

      return acc.concat(...entities);
    }, []);
  }

  return [].concat(iabEntityTypes, keywordEntityTypes, labelEntityTypes);
};

export const getVideoEntityTypes = (tagTypes) => {
  const usersTagTypes = tagTypes || [];
  const videoEntityTypes = usersTagTypes.filter((tagType) => ![CUSTOM_TAG_NAME, CUSTOM_TAG_VALUE].includes(tagType));

  if (usersTagTypes.length !== videoEntityTypes.length) {
    videoEntityTypes.push(CUSTOM_TAG);
  }

  return videoEntityTypes;
};
